import { render, staticRenderFns } from "./CountrySwitcher.vue?vue&type=template&id=d2d70334&"
import script from "./CountrySwitcher.vue?vue&type=script&lang=js&"
export * from "./CountrySwitcher.vue?vue&type=script&lang=js&"
import style0 from "./CountrySwitcher.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports